var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogistics = function SvgLogistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logistics_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h22v22H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logistics_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24961B",
    d: "M2 4h11v12H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24961B",
    fillRule: "evenodd",
    d: "M12.5 7.5h4L20 12v4.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#24961B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.83 16.5v-11c0-.51-.18-.94-.54-1.3A1.76 1.76 0 0 0 11 3.66H3.66c-.5 0-.94.18-1.29.54-.36.36-.54.79-.54 1.3v10.08c0 .61.3.92.92.92h1.83m9.17 0h-5.5m9.16 0h1.84c.61 0 .91-.31.91-.92v-3.35c0-.21-.07-.4-.2-.57l-3.19-3.99a.86.86 0 0 0-.71-.34h-3.23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.583,
    cy: 16.5,
    r: 1.833,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.583,
    cy: 16.5,
    r: 1.833,
    stroke: "#24961B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.417,
    cy: 16.5,
    r: 1.833,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.417,
    cy: 16.5,
    r: 1.833,
    stroke: "#24961B",
    strokeLinejoin: "round"
  }))));
};
export default SvgLogistics;